// extracted by mini-css-extract-plugin
export default {"container":"style_container__aHp+K","cardChild":"style_cardChild__KffkU","formStyle":"style_formStyle__LWNVb","footer":"style_footer__G54fT"};